var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_2088)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_2088",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_2088)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7882 20C38.5538 20 39.2954 19.8972 40 19.7047C39.4398 19.5865 38.859 19.5244 38.2638 19.5244H28.371C26.737 19.5244 25.2122 19.0562 23.9238 18.2467C24.2054 16.5979 24.9826 15.0173 26.2554 13.7446L32.5782 7.42188C33.1196 6.88048 33.5712 6.28338 33.9334 5.64904C33.4536 5.96158 32.999 6.32832 32.5782 6.74926L25.5828 13.7446C24.4274 14.9 23.0182 15.647 21.5348 15.9857C20.568 14.6207 20 12.9534 20 11.1535V2.21186C20 1.44621 19.8972 0.70458 19.7047 0C19.5865 0.560142 19.5244 1.14093 19.5244 1.73624V11.6291C19.5244 13.2631 19.0562 14.7878 18.2467 16.0762C16.5979 15.7945 15.0173 15.0173 13.7446 13.7446L7.42188 7.42188C6.88048 6.88048 6.28338 6.42874 5.64904 6.06668C5.96158 6.5463 6.32832 7.00094 6.74926 7.42188L13.7446 14.4172C14.9 15.5726 15.647 16.9818 15.9857 18.4653C14.6207 19.4319 12.9534 20 11.1535 20H2.21186C1.44621 20 0.704578 20.1028 0 20.2954C0.560146 20.4134 1.14094 20.4756 1.73624 20.4756H11.6291C13.2631 20.4756 14.7878 20.9438 16.0762 21.7534C15.7945 23.402 15.0173 24.9826 13.7446 26.2554L7.42188 32.5782C6.8805 33.1196 6.42876 33.7166 6.0667 34.351C6.54632 34.0384 7.00094 33.6716 7.42188 33.2508L14.4172 26.2554C15.5726 25.1 16.9818 24.353 18.4653 24.0142C19.4319 25.3794 20 27.0466 20 28.8466V37.7882C20 38.5538 20.1028 39.2954 20.2954 40C20.4134 39.4398 20.4756 38.859 20.4756 38.2638V28.3708C20.4756 26.7368 20.9438 25.2122 21.7534 23.9238C23.402 24.2054 24.9826 24.9826 26.2554 26.2554L32.5782 32.5782C33.1196 33.1196 33.7166 33.5712 34.351 33.9334C34.0384 33.4536 33.6716 32.999 33.2508 32.5782L26.2554 25.5828C25.1 24.4274 24.353 23.0182 24.0144 21.5348C25.3794 20.568 27.0466 20 28.8466 20H37.7882Z",
    fill: "#B5C989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_2088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar20);
export default __webpack_public_path__ + "static/media/star-20.a75d396009da64d71a87ee42a7787552.svg";
export { ForwardRef as ReactComponent };